import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import FormLabel from "@material-ui/core/FormLabel";

import Button from "common/components/CustomButtons/Button.jsx";
import Phone from "@material-ui/icons/Phone";
import EasySelect from "common/components/EasyForm/EasySelect";

import loadForm from "core-module/hoc/loadForm";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center",
    fontSize: "15px"
  },
  containerLine: {},
  editButton: {
    textAlign: "right",
    margin: "10px"
  }
};

const LongDistanceBalanceWizard = props => {
  const { classes } = props;
  return (
    <GridContainer justify="center">
      <GridItem xs={12} lg={6}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Phone />
            </CardIcon>
            <h4 className={classes.cardIconTitle}> Add</h4>
          </CardHeader>
          <CardBody>
            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  Select Amount
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <EasySelect propName="amount" connectForm={props.connectForm} />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={6}>
                <Button
                  fullWidth
                  onClick={props.closeWizard}
                  color="primaryRed"
                >
                  Cancel
                </Button>
              </GridItem>
              <GridItem xs={12} sm={6}>
                <Button
                  fullWidth
                  onClick={() =>
                    props.onFinishLongDistanceBalanceWizard(
                      props.ids,
                      props.connectForm.getFormState()
                    )
                  }
                  color="primaryLightBlue"
                >
                  Submit
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(
  loadForm(
    "user.session/billingpackage.props/voipldhistory.props",
    LongDistanceBalanceWizard
  )
);
